<template>
    <div class="row">
        <div class="col-sm-12 col-md-12" v-if="ping">
            <div class="alert-message alert-message-success">
                <h4>
                    <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                    <span v-if="tipo === 'RADIO'">Rádio</span>
                    <span v-else="">Roteador</span> do Cliente: ONLINE
                </h4>
                <p></p>
            </div>
        </div>
        <div class="col-sm-12 col-md-12" v-else-if="ping === false">
            <div class="alert-message alert-message-danger">
                <h4>
                    <i class="fa fa-thumbs-o-down" aria-hidden="true"></i>
                    <span v-if="tipo === 'RADIO'">Rádio</span>
                    <span v-else>Roteador</span> do Cliente: OFFLINE
                </h4>
                <p></p>
            </div>
        </div>
        <div class="col-sm-12 col-md-12" v-else>
            <div class="alert-message alert-message-default">
                <h4>
                    <i class="fa fa-spinner" aria-hidden="true"></i>
                    Verificando Status
                </h4>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        usuario: {
            default: null
        },
        ip: {
            default: null
        },
        id: {
            default: null
        },
        tipo: {
            default: "RADIO"
        }
    },

    data() {
        return {
            ping: null,
            socket: null,
            interval: null
        };
    },

    mounted() {
        setTimeout(() => this.pingar(), 100);
    },

    sockets: {
        pingStatus(data) {
            if (data.ip && this.ip === data.ip) {
                this.ping = data.data;
            } else if (data.id && this.id === data.id) {
                this.ping = data.data;
                this.$emit("ip", data.ip);
            } else if (data.username && this.usuario === data.username) {
                this.ping = data.data;
            }
        }
    },

    beforeMount() {
        this.interval = setInterval(this.pingar, 20000);
    },

    beforeDestroy() {
        clearInterval(this.interval);
    },

    methods: {
        connect() {
            this.pingar();
        },

        pingar() {
            if (this.usuario) {
                this.$socket.emit("user-online", { username: this.usuario });
            } else if (this.id) {
                this.$socket.emit("online", { id: this.id });
            } else if (this.ip) {
                this.$socket.emit("pingIN", { ip: this.ip });
            }
        }
    }
};
</script>
<style>
.alert-message {
    margin: 20px 0;
    padding: 20px;
    border-left: 3px solid #eee;
}

.alert-message h4 {
    margin-top: 0;
    margin-bottom: 5px;
}

.alert-message p:last-child {
    margin-bottom: 0;
}

.alert-message code {
    background-color: #fff;
    border-radius: 3px;
}

.alert-message-success {
    background-color: #f4fdf0;
    border-color: #3c763d;
}

.alert-message-success h4 {
    color: #3c763d;
}

.alert-message-danger {
    background-color: #fdf7f7;
    border-color: #d9534f;
}

.alert-message-danger h4 {
    color: #d9534f;
}

.alert-message-warning {
    background-color: #fcf8f2;
    border-color: #f0ad4e;
}

.alert-message-warning h4 {
    color: #f0ad4e;
}

.alert-message-info {
    background-color: #f4f8fa;
    border-color: #5bc0de;
}

.alert-message-info h4 {
    color: #5bc0de;
}

.alert-message-default {
    background-color: #eee;
    border-color: #b4b4b4;
}

.alert-message-default h4 {
    color: #000;
}

.alert-message-notice {
    background-color: #fcfcdd;
    border-color: #bdbd89;
}

.alert-message-notice h4 {
    color: #444;
}
</style>
